import { formatDateTimePair } from "../../../lib/timezone.js";

export interface TimezoneLabelsProps {
  readonly iso: string;
  readonly venueTimeZone?: string | null;
  readonly compact?: boolean;
  readonly className?: string;
}

export function TimezoneLabels(props: TimezoneLabelsProps) {
  const pair = formatDateTimePair(props.iso, props.venueTimeZone);
  return (
    <div
      className={props.className ?? "flex flex-col gap-1.5 text-sm"}
      data-testid="timezone-labels"
    >
      <span className="min-w-0 break-words">
        <span className="pwz-eyebrow mr-1.5">
          {props.compact ? "Устройство" : "Время устройства"}
        </span>
        <span className="pwz-readout text-ink-950">{pair.deviceLabel}</span>
      </span>
      {pair.venueLabel ? (
        <span className="min-w-0 break-words">
          <span className="pwz-eyebrow mr-1.5">
            {props.compact ? "Площадка" : "Время площадки"}
          </span>
          <span className="pwz-readout text-ink-800">{pair.venueLabel}</span>
        </span>
      ) : (
        <span className="pwz-eyebrow normal-case">
          Пояс площадки совпадает с устройством ({pair.deviceTimeZone})
        </span>
      )}
    </div>
  );
}
